import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import OfferEdit from "./OfferEdit";
import { useOfferLoader } from "../hooks/OfferLoaderHook";
import { createEmptyOffer } from "../types/CommercialDocumentTypes";

import type { Offer } from "../types/CommercialDocumentTypes";

export const OfferEditPage = () => {
	const { id } = useParams<{ id: string }>();
	const { t } = useTranslation();

	const [offer, setOffer] = useState<Offer>(createEmptyOffer());
	const [hasOffer, setHasOffer] = useState<boolean>(false);

	const { fetchData, loading } = useOfferLoader({
		onFetched: (offer) => {
			setOffer(offer);
			setHasOffer(true);
		},
	});

	useEffect(() => {
		setHasOffer(false);
		if (id && id !== "new") fetchData(id);
		if (id === "new") {
			setOffer(createEmptyOffer());
			setHasOffer(true);
		}
	}, [id]);

	return (
		<Box
			style={{
				minHeight: "90vh",
				height: "auto",
				width: "100%",
				position: "relative",
			}}>
			{loading ? (
				<Box display="flex" justifyContent="center" alignItems="center" height="100vh">
					<CircularProgress />
				</Box>
			) : hasOffer ? (
				<OfferEdit offer={offer} setOffer={setOffer} />
			) : (
				<Box textAlign="center">
					<Typography variant="h6">{t("nothing-available")}</Typography>
				</Box>
			)}
		</Box>
	);
};
